import { cn } from '@/lib/utils';

type CardProps = React.ComponentProps<'div'> & {
  size?: 'default' | 'sm';
};

// These are classes that override shadcn styles in order to mimic paragon until we fully migrate.
const PARAGON_OVERRIDE_CLASSES =
  'tw-shadow-card !tw-ring-foreground/0 !tw-rounded-md';

export const Card = ({ className, size = 'default', ...props }: CardProps) => (
  <div
    data-slot="card"
    data-size={size}
    className={cn(
      'tw-ring-foreground/10 tw-bg-card tw-text-card-foreground tw-gap-4 tw-overflow-hidden tw-rounded-xl tw-py-4 tw-text-sm tw-ring-1 has-data-[slot=card-footer]:tw-pb-0 has-[>img:first-child]:tw-pt-0 data-[size=sm]:tw-gap-3 data-[size=sm]:tw-py-3 data-[size=sm]:has-data-[slot=card-footer]:tw-pb-0 *:[img:first-child]:tw-rounded-t-xl *:[img:last-child]:tw-rounded-b-xl group/card tw-flex tw-flex-col',
      PARAGON_OVERRIDE_CLASSES,
      className,
    )}
    {...props}
  />
);
